/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/635/interface/api/cat_6566
 */
import { message } from 'ant-design-vue'
import {
  payMethod_queryConfig_post,
  payMethod_deleteConfig_post,
  payMethod_listConfig_post,
  payMethod_saveConfig_post,
  payMethod_changeSort_post
} from 'server/modules/6566' // 查询配置信息(C端)

export const payMethod_queryConfig_post_ = async function(params) {
  const { success, data, retInfo } = await payMethod_queryConfig_post(params)

  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // 刪除配置信息

export const payMethod_deleteConfig_post_ = async function(params, state) {
  const { success, retInfo } = await payMethod_deleteConfig_post(params)

  if (success) {
    state.initList()
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // 配置信息列表

export const payMethod_listConfig_post_ = async function(params, state) {
  const { success, data, retInfo } = await payMethod_listConfig_post(params)

  if (success) {
    state.dataSource = data
  } else {
    message.error(retInfo)
  }
} // 保存配置信息

export const payMethod_saveConfig_post_ = async function(params, state) {
  const { success, retInfo } = await payMethod_saveConfig_post(params)

  if (success) {
    state.initList()
    state.changeVisible(false)
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 更改排序
export const payMethod_changeSort_post_ = async function(params, state) {
  const { success, retInfo } = await payMethod_changeSort_post(params)
  if (success) {
    state.initList()
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
